export default __webpack_public_path__ + "static/roaring-acdb1b8b144afb774d5da981bb2050b3.svg";